import { heicTo } from "heic-to";

export function isHeicFile(file: File): boolean {
  const type = file.type.toLowerCase();
  const name = file.name.toLowerCase();
  return (
    type === "image/heic" ||
    type === "image/heif" ||
    name.endsWith(".heic") ||
    name.endsWith(".heif")
  );
}

export function isHeicUrl(url: string): boolean {
  const lowerUrl = url.toLowerCase();
  return lowerUrl.includes(".heic") || lowerUrl.includes(".heif");
}

export async function convertHeicToJpeg(file: File): Promise<File> {
  const jpegBlob = await convertHeicBlobToJpeg(file)

  let newName = file.name.replace(/\.heic$/i, ".jpg").replace(/\.heif$/i, ".jpg");
  if (!newName.toLowerCase().endsWith(".jpg") && !newName.toLowerCase().endsWith(".jpeg")) {
    newName = newName + ".jpg";
  }

  return new File([jpegBlob], newName, { type: "image/jpeg" });
}

export async function convertHeicBlobToJpeg(blob: Blob): Promise<Blob> {
  return await heicTo({
    blob,
    type: "image/jpeg",
    quality: 0.8,
  });
}
